<template>
	<div class="modal__content">
		<p class="text-center mb20">Are you sure you want to remove task from this project?</p>

		<div class="flex flex--justify-center">
			<button class="btn btn--wide btn--gray-2 mr10" @click="$bus.$emit('modalClose')" type="button">No</button>
			<button class="btn btn--wide" @click="onConfirm">Yes</button>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import { apiProjectTaskRemove } from '@/api/project.api'

export default {
  data () {
    return {}
  },

  props: ["args"],

  methods: {
    ...mapActions([
      'removeTask'
    ]),
    async onConfirm () {
      this.$bus.$emit('loaderShow')
      const projectID = this.$route.params.id
      const [err] = await apiProjectTaskRemove(projectID, this.args)
      if (err) return errorMessage(err, 'Unable to delete task. Try again later!')

      this.$bus.$emit('modalClose')

      this.removeTask(this.args)

      this.$bus.$emit('loaderClose')
      this.$bus.$emit('toastSuccess', 'Task successfully removed')
    }
  }
}
</script>


// WEBPACK FOOTER //
// RemoveTaskModal.vue?d5202490